export default __webpack_public_path__ + "static/media/healthrite.7e0e8f71.png";